/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_norm_field_assay = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assay / purity (%)`)
};

const es_norm_field_assay = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ensayo / pureza (%)`)
};

const de_norm_field_assay = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehalt / Reinheit (%)`)
};

const nl_norm_field_assay = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehalte / zuiverheid (%)`)
};

const fr_norm_field_assay = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre / pureté (%)`)
};

const it_norm_field_assay = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titolo / purezza (%)`)
};

const pt_br2_norm_field_assay = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teor / pureza (%)`)
};

const pt_norm_field_assay = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título / pureza (%)`)
};

const ja_norm_field_assay = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アッセイ／純度 (%)`)
};

const zh_norm_field_assay = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`含量 / 纯度（%）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const norm_field_assay = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.norm_field_assay(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("norm_field_assay", locale)
	if (locale === "en") return en_norm_field_assay(inputs)
	if (locale === "es") return es_norm_field_assay(inputs)
	if (locale === "de") return de_norm_field_assay(inputs)
	if (locale === "nl") return nl_norm_field_assay(inputs)
	if (locale === "fr") return fr_norm_field_assay(inputs)
	if (locale === "it") return it_norm_field_assay(inputs)
	if (locale === "pt-BR") return pt_br2_norm_field_assay(inputs)
	if (locale === "pt") return pt_norm_field_assay(inputs)
	if (locale === "ja") return ja_norm_field_assay(inputs)
	return zh_norm_field_assay(inputs)
};